import User, { Roles } from '../models/User';

export function isUserAdmin(user: User | null) {
  const adminRoles = [Roles.NETWORK_ADMIN, Roles.SITE_ADMIN];
  return adminRoles.some(role => user?.roles?.some(userRole => userRole?.name === role));
}
